import { Card } from "@/components/ui/card";
import { Avatar } from "@/components/ui/avatar";
import { User } from "lucide-react";
import { SafeMarkdown } from "@/components/markdown/SafeMarkdown";
import remarkGfm from "remark-gfm";
import "@github/relative-time-element";

type ChatUserBubbleProps = {
  content: string;
  createdAt?: string;
  compact?: boolean;
};

export function ChatUserBubble({ content, createdAt, compact = false }: ChatUserBubbleProps) {
  const avatarClass = compact
    ? "h-8 w-8 flex items-center justify-center border rounded-full dark:border-gray-600 bg-primary text-primary-foreground"
    : "h-8 w-8 lg:h-14 lg:w-14 flex items-center justify-center border rounded-full dark:border-gray-600 bg-primary text-primary-foreground";

  // Tinted and inset from the left so the user's turns read as a distinct
  // column against the full-width assistant answers. bg-secondary is the only
  // surface that differs from the card default: --muted and --accent are both
  // defined as the same value.
  return (
    <Card className="ml-auto w-[92%] p-4 bg-secondary">
      <div className={compact ? "prose prose-sm dark:prose-invert max-w-none mb-4" : "prose dark:prose-invert max-w-none mb-8"}>
        <SafeMarkdown remarkPlugins={[remarkGfm]}>{content}</SafeMarkdown>
      </div>
      <div className="flex items-center gap-2 justify-end">
        {createdAt ? (
          <relative-time datetime={createdAt} className="text-sm text-muted-foreground" />
        ) : null}
        <Avatar className={avatarClass}>
          <User />
        </Avatar>
      </div>
    </Card>
  );
}
